import React from 'react';

import { ReactComponent as ErrorImage } from '../../../assets/icons/error-page.svg';
import { ReactComponent as ErrorImageNE } from '../../../assets/icons/ne-error-page.svg';
import { GenericFunction } from '../../types/genericTypes';
import StyledButtonNE from '../StyledButtonNE/StyledButtonNE';

import './styles.scss';

interface CustomEmptyPageProps {
  title: string;
  subtitle: string;
  newExperience?: boolean;
  CustomImage?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string | undefined }>;
  buttonText?: string;
  buttonAction?: GenericFunction;
}

const CustomEmptyPage = ({
  title,
  subtitle,
  newExperience,
  CustomImage,
  buttonText,
  buttonAction
}: CustomEmptyPageProps) => {
  const hasButton = () => buttonAction && buttonText;
  return newExperience ? (
    <div className="empty-state-container">
      {CustomImage ? <CustomImage className="image" /> : <ErrorImageNE className="image" />}
      <div className="ne-font-heading-lg mb-5">{title}</div>
      <div className="description-container">
        <div className="ne-font-body-xl">{subtitle}</div>
      </div>
      {hasButton() && (
        <div className="empty-state-button-container">
          <StyledButtonNE buttonType="secondary" buttonSize="md" action={buttonAction}>
            {buttonText}
          </StyledButtonNE>
        </div>
      )}
    </div>
  ) : (
    <div className="empty-state-container">
      <ErrorImage className="image" />
      <div className="title">{title}</div>
      <div className="description-container">
        <div className="subtitle">{subtitle}</div>
      </div>
    </div>
  );
};

export default CustomEmptyPage;
